import React, { useState, useEffect } from 'react';
import { notification } from 'antd';
import axios from 'axios';

import { API_URL, ENDPOINTS } from '../constants/api';
import '../css/modal.css';
import { getToken } from '../utils/TokenUtils';

const SmsModal = ({ defaultSms, title, data, isOpen, onRequestClose }) => {
  const [sms, setSms] = useState(defaultSms);
  const [type, setType] = useState('Notification');
  const [loading, setLoading] = useState(false);
  const [finalMessage, setFinalMessage] = useState(defaultSms);

  // Get first row from the array
  const firstRow = data[0] || {};

  // Normalize keys to lowercase
  const lowerCasedData = Object.keys(firstRow).reduce((acc, key) => {
    acc[key.toLowerCase()] = firstRow[key];
    return acc;
  }, {});
  // Check for "tell" key
  const hasTell = 'tell' in lowerCasedData;

  const onChangeSms = (e) => {
    const { value } = e.target;
    // console.log(value);
    const finalMessage = hasTell
      ? generateSMS(value, lowerCasedData)
      : "To send sms please check if report contains 'Tell' column, or select rows ";
    setFinalMessage(finalMessage);
    setSms(value);
  };
  const onChangeType = (e) => {
    const { value } = e.target;

    setType(value);
  };

  // Replace placeholders
  const generateSMS = (template, data) => {
    return template.replace(/\[([^\]]+)]/g, (_, key) => {
      const lowerKey = key.toLowerCase();
      return data[lowerKey] !== undefined ? data[lowerKey] : '';
    });
  };

  useEffect(() => {
    const finalMessage2 = hasTell
      ? generateSMS(sms, lowerCasedData)
      : "To send sms please check if report contains 'Tell' column, or select rows ";
    setFinalMessage(finalMessage2);
  }, []);

  const token = getToken();

  const handleSendSMS = async () => {
    const messagesToSend = [];
    setLoading(true);
    data.forEach((row) => {
      // Normalize keys to lowercase
      const normalized = Object.keys(row).reduce((acc, key) => {
        acc[key.toLowerCase()] = row[key];
        return acc;
      }, {});

      if (normalized.tell) {
        const customSms = generateSMS(sms, normalized);
        messagesToSend.push({
          tell: normalized.tell,
          sms: customSms,
          type: type,
        });
      }
    });

    if (messagesToSend.length === 0) {
      console.log('no one to send this sms');
      return;
    }

    console.log('messagesToSend:', messagesToSend);

    try {
      const response = await axios.post(
        `${API_URL}/${ENDPOINTS.SYS}/send-bulk-sms`,
        {
          messages: messagesToSend,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Sending Bearer token in the header
          },
        }
      );
      console.log('SMS sent:', response.data);
      setLoading(false);
      notification.success({
        message: `${response.data.successMessages.length} sent success, ${response.data.failedMessages.length} failed to  send`,
      });
    } catch (error) {
      console.error('Error sending SMS:', error);
      notification.error({ message: 'Error sending smsm' });
      setLoading(false);
    }
  };

  const handleSendWASMS = async () => {
    const messagesToSend = [];
    setLoading(true);
    data.forEach((row) => {
      // Normalize keys to lowercase
      const normalized = Object.keys(row).reduce((acc, key) => {
        acc[key.toLowerCase()] = row[key];
        return acc;
      }, {});

      if (normalized.tell) {
        const customSms = generateSMS(sms, normalized);
        messagesToSend.push({
          tell: normalized.tell,
          sms: customSms,
          type: type,
        });
      }
    });

    if (messagesToSend.length === 0) {
      console.log('no one to send this sms');
      return;
    }

    console.log('messagesToSend:', messagesToSend);

    try {
      const response = await axios.post(
        `${API_URL}/${ENDPOINTS.SYS}/send-bulk-wa-sms`,
        {
          messages: messagesToSend,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Sending Bearer token in the header
          },
        }
      );
      console.log('SMS sent:', response.data);
      setLoading(false);
      notification.success({
        message: `${response.data.successMessages.length} sent success, ${response.data.failedMessages.length} failed to  send`,
      });
    } catch (error) {
      console.error('Error sending SMS:', error);
      notification.error({ message: 'Error sending smsm' });
      setLoading(false);
    }
  };

  return (
    <div
      className={`modal fade ${isOpen ? 'show' : ''}`}
      style={{ display: isOpen ? 'block' : 'none' }}
      tabIndex="-1"
      aria-hidden={isOpen ? 'false' : 'true'}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content  ">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onRequestClose}
            ></button>
          </div>
          <div className="modal-body ">
            <p>Sms type</p>
            <input
              value={type}
              onChange={onChangeType}
              name="type"
              placeholder="Sms type"
              className="form-control"
            />
            <br />
            <textarea
              value={sms}
              onChange={onChangeSms}
              name="sms"
              className="form-control"
              rows={5}
            ></textarea>

            <p>
              {finalMessage?.length} characters ={' '}
              {Math.ceil(finalMessage?.length / 160)} sms - to {data?.length}{' '}
              person = $
              {Math.ceil(finalMessage?.length / 160) * 0.015 * data?.length}
            </p>
            <p>Message: {finalMessage}</p>

            <button
              type="button"
              className="btn btn-secondary ms-2"
              onClick={onRequestClose}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary ms-2"
              onClick={handleSendSMS}
            >
              Send selected: {data.length} Sms - $
              {Math.ceil(finalMessage?.length / 160) * 0.015 * data?.length}
            </button>
            <button
              type="button"
              className="btn btn-primary ms-2"
              onClick={handleSendWASMS}
            >
              Send Wshatsapp selected: {data.length} Sms
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmsModal;
